<template>
  <div
    :class="[orientation, size]"
    class="borderPage"
  >
    <div
      :id="id"
      :class="[orientation, size, pageClass]"
      class="reportPage"
    >
      <div
        v-if="header"
        class="kiwaHeader"
      >
        <img
          :src="env.assets_url + '/assets/report/kiwa_compliance.jpg'"
          class="headerImage"
        >
      </div>
      <div
        v-if="!isFullHeight"
        class="kiwaContent"
      >
        <slot />
      </div>
      <div v-else>
        <slot />
      </div>
      <div
        v-if="footer"
        class="kiwaFooter"
      >
        <div class="footerP">
          <span class="footerText">
            Projectnummer {{ project.nummer }}, versie <span v-if="reportsettings">{{ reportsettings.major_version }}.{{ reportsettings.minor_version }}</span>
          </span>
        </div>
        <div class="footerP">
          <span class="footerText">
            {{ asset.straatnaam }} {{ asset.huisnummer }} {{ asset.toevoeging }} te {{ asset.plaats }}
          </span>
        </div>
        <div class="footerPageNum">
          <span class="footerText">pagina </span>
          <span class="footerText">{{ pageNr }}/{{ pageTotal - 1 }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { ReportUtils } from 'components/report'
import { mapState } from 'vuex'
import Vue from 'vue'

export default {
  props: {
    onderzoek: Object,
    reportsettings: Object,
    header: { type: Boolean, default: true },
    footer: { type: Boolean, default: true },
    orientation: {
      type: String,
      default: 'portrait'
    },
    size: {
      type: String,
      default: 'a4'
    },
    pageClass: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      id: Math.round(Math.random() * 500),
      env: {
        assets_url: process.env.ASSETS_URL
      },
      timeoutRequest: null,
      pageNr: 0,
      pageTotal: 0,
      isFullHeight: false
    }
  },
  computed: {
    asset () {
      if (!this.onderzoek) {
        return {}
      }
      return this.onderzoek.inventarisatie_asset?.asset || {}
    },
    project () {
      if (!this.onderzoek) {
        return {}
      }
      return this.onderzoek.project
    }
  },
  destroyed () {
    const generated = document.querySelectorAll('.generatedPage')
    if (generated?.length) {
      for (let i = 0; i < generated.length; i++) {
        generated[i].remove()
      }
    }
  },
  mounted () {
    if (!this.header && !this.footer) {
      this.isFullHeight = true
    }
    else {
      window.setTimeout(() => {
        this.fixOverflow()
      }, 500)
    }
  },
  methods: {
    calcPageNo () {
      const pages = document.querySelectorAll('.reportContent .reportPage')
      this.pageTotal = pages.length
      const thisPage = this.$el.querySelector('.reportPage')

      for (let i = 0; i < pages.length; i++) {
        if (+thisPage.id === +pages[i].id || +this.id === +pages[i].id) {
          this.pageNr = i
          this.$emit('page_calculated', i)
          break
        }
      }
    },
    addNewPage (removed) {
      const that = this
      const el = document.createElement('DIV')

      const content = document.createElement('div')

      for (let i = removed.length - 1; i >= 0; i--) {
        content.appendChild(removed[i])
      }

      const Component = Vue.extend({
        parent: this.$parent,
        data () {
          return {
            onderzoek: that.onderzoek,
            header: that.header,
            footer: that.footer,
            reportsettings: that.reportsettings,
            orientation: that.orientation,
            size: that.size
          }
        },
        computed: {
          ...mapState({
            tables: state => state.rapportage.tables
          })
        },
        template: '<report-page :size="size" :reportsettings="reportsettings" :header="header" :footer="footer" :orientation="orientation" :onderzoek="onderzoek" class="generatedPage">' + content.innerHTML + '</report-page>'
      })
      this.$el.insertAdjacentElement('afterend', el)

      new Component().$mount(el)
    },
    fixOverflow () {
      // this.$el is undefined in a recursively compiled template or something
      if (this.$el?.querySelector) {
        this.calcPageNo()
        const content = this.$el.querySelector('.kiwaContent')
        if (ReportUtils.checkOverflow(content)) {
          const removed = []
          let breakLoop = false
          // Start at the last children, remove it and add to removed array, check for overflow
          for (let i = (content.children.length - 1); i >= 0 && !breakLoop; i--) {
            // Removing individual fotos
            if (content.children[i].classList.contains('bronfotos')) {
              const fotos = content.children[i].querySelectorAll('.fotoContainer')
              const newFotoContainer = document.createElement('div')
              newFotoContainer.innerHTML = content.children[i].innerHTML
              newFotoContainer.classList = content.children[i].classList

              const newFotos = newFotoContainer.querySelectorAll('.fotoContainer')

              let rowNumToRemove = fotos.length

              for (let j = fotos.length - 1; j > 1 && !breakLoop; j--) {
                rowNumToRemove--
                fotos[j].remove()
                if (!ReportUtils.checkOverflow(content)) {
                  // Loop only to rowNumToRemove - 1 because 1 gets added in the next line
                  for (let k = 0; k < rowNumToRemove - 1; k++) {
                    newFotos[k + 1].remove()
                  }
                  removed.push(newFotoContainer)
                  breakLoop = true
                  break
                }
              }
              if (!breakLoop) {
                content.children[i].remove()
                removed.push(newFotoContainer)
                if (!ReportUtils.checkOverflow(content)) {
                  breakLoop = true
                  break
                }
              }
            }
            else if (content.children[i].tagName.toLowerCase() === 'p') {
              const lines = content.children[i].innerHTML.split(/\r?\n/g)
              if (lines.length > 10) {
                const newP = document.createElement('p')
                newP.innerHTML = ''
                newP.classList = content.children[i].classList

                const newLines = []

                const len = lines.length

                for (let j = 0; j < len && !breakLoop; j++) {
                  newLines.push(lines.pop())
                  content.children[i].innerHTML = lines.join('\r\n')
                  if (!ReportUtils.checkOverflow(content)) {
                    newLines.reverse()
                    newP.innerHTML = newLines.join('\r\n')
                    removed.push(newP)
                    console.log('P has half moved', newP, lines)
                    breakLoop = true
                    break
                  }
                }
                if (!breakLoop) {
                  console.log('P has fully moved', newP, lines)
                  content.children[i].remove()
                  newLines.reverse()
                  newP.innerHTML = newLines.join('\r\n')
                  removed.push(newP)
                  if (!ReportUtils.checkOverflow(content)) {
                    breakLoop = true
                    break
                  }
                }
              }
              else {
                removed.push(content.children[i])
                content.children[i].remove()
                if (!ReportUtils.checkOverflow(content)) {
                  breakLoop = true
                  break
                }
              }
            }
            // If table we'll remove rows untill no overflow, or whole table
            else if (content.children[i].tagName.toLowerCase() === 'table') {
              const rows = content.children[i].querySelectorAll('tr')

              const newTable = document.createElement('table')
              newTable.innerHTML = content.children[i].outerHTML
              newTable.classList = content.children[i].classList
              newTable.setAttribute('data-table', content.children[i].getAttribute('data-table'))
              newTable.innerHTML = newTable.innerHTML.replace('table :', `table {{tables.${newTable.getAttribute('data-table')}}}:`)

              const newRows = newTable.querySelectorAll('tr')

              let rowNumToRemove = rows.length

              for (let j = rows.length - 1; j > 1 && !breakLoop; j--) {
                rowNumToRemove--
                rows[j].remove()
                if (!ReportUtils.checkOverflow(content)) {
                  // Loop only to rowNumToRemove - 1 because 1 gets added in the next line
                  for (let k = 0; k < rowNumToRemove - 1; k++) {
                    newRows[k + 1].remove()
                  }
                  removed.push(newTable)
                  breakLoop = true
                  break
                }
              }
              if (!breakLoop) {
                content.children[i].remove()
                removed.push(newTable)
                if (!ReportUtils.checkOverflow(content)) {
                  breakLoop = true
                  break
                }
              }
            }
            else {
              removed.push(content.children[i])
              content.children[i].remove()
              if (!ReportUtils.checkOverflow(content)) {
                breakLoop = true
                break
              }
            }
          }
          console.log('Overflow on page ' + this.pageNr + ', moved to next page: ', removed)
          this.addNewPage(removed)
        }
        else {
          this.$emit('render-done')
          if (this.timeoutRequest) {
            clearTimeout(this.timeoutRequest)
            this.timeoutRequest = null
          }
          this.timeoutRequest = setTimeout(() => { this.calcPageNo() }, 1000)
        }
      }
      else {
        this.$emit('render-done')
        if (this.timeoutRequest) {
          clearTimeout(this.timeoutRequest)
          this.timeoutRequest = null
        }
        this.timeoutRequest = setTimeout(() => { this.calcPageNo() }, 1000)
      }
    }
  }
}
</script>
